import React from "react";
import { TYPE_PC, TYPE_SP } from "../../common/defines";
import { modal } from "../modal";
import { Player } from 'video-react';

export const modal_video = props => {
  const { videoUrl, type } = props;
  let url = videoUrl;
  return (
    <div className="modal_video modal_base">
      <div className="cross" onClick={() => modal.closeModal()} />
      <Player
      	  fluid={false}
          width={type == TYPE_PC ? 650 : 'auto'}
          height={type == TYPE_SP ? 181 : '366'}
      	  playsInline={false}
	      src={url}
	    />
    </div>
  );
};



// WEBPACK FOOTER //
// ./common/modal/modal_video.jsx